import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Place } from "../../types/Place";
import "./PlaceSearchResult.scss";

interface PlaceSearchResultProps {
  place: Place;
}

const PlaceSearchResult: React.FC<PlaceSearchResultProps> = ({ place }) => {
  const navigate = useNavigate();

  const handlePlaceClick = useCallback(() => {
    navigate(`/place/${place.googlePlaceId}`, {
      state: { place },
    });
  }, [navigate, place]);

  return (
    <div className="place-search-result" onClick={handlePlaceClick}>
      <h3 className="place-name">{place.name}</h3>
      <p className="place-address">{place.address}</p>
    </div>
  );
};

export default PlaceSearchResult;
